<template>
  <div class="seckill-page">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
      <seckill-item
        v-for="item in seckillList"
        :key="item.id"
        :item="item"
        :isself="self"
        :ismyseckill="ismyseckill"
        @viewApplyDetail="viewApplyDetail"
      ></seckill-item>
    </van-list>
  </div>
</template>

<script>
import BottomNav from "./../../components/bottom-nav";

import SeckillItem from "./../../components/seckill-item";
export default {
  components: {
    SeckillItem,
    BottomNav,
  },
  data() {
    return {
      seckillList: [],
      finished: false,
      loading: false,
      self: true,
      ismyseckill: true,
    };
  },
  created() {
    this.$initWXSDK({}, () => {
      this.$utils.getLocation().then((res) => {});
    });
    this.getMySeckill();
  },
  methods: {
    viewApplyDetail(item) {
      const that = this;
      that.$dialog({
        title: "使用详情",
        message: `核销时间：${item.finishTime}\n\n核销员工：${
          item.kpiUserName || "-"
        }\n\n核销门店：${item.kpiUserShop || "-"}\n\n核销品牌：${
          item.kpiUserBrand || "-"
        }\n\n`,
      });
    },
    getMySeckill() {
      this.$http.post("/v1/seckill/my_seckill").then((res) => {
        if (res.code === 0) {
          this.finished = true;
          this.seckillList = res.data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.seckill-page {
  min-height: 100vh;
  background: #fff;
  padding: 0 15px;
}
</style>